import { Typography } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { TOC_LINK_VARIANTS, type TocLinkVariant } from '../types';

type Props = PropsWithChildren<{
  bold: boolean;
  variant?: TocLinkVariant;
}>;

export function SectionName({ children, bold, variant = TOC_LINK_VARIANTS.DEFAULT }: Props) {
  const isLinearProgressVariant = variant === TOC_LINK_VARIANTS.LINEAR_PROGRESS;
  return (
    <Typography
      variant={bold ? 'textBold' : 'text'}
      sx={{
        fontSize: isLinearProgressVariant ? '16px' : '14px',
        px: bold || isLinearProgressVariant ? '0px' : '2px',
        display: 'inline-block',
      }}
    >
      {children}
    </Typography>
  );
}
